export default __webpack_public_path__ + "static/media/logo.7841b2d4.svg";